import * as React from 'react';

const TextChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M4 4v4h2V6h5v12H9v2h6v-2h-2V6h5v2h2V4z" />
    </svg>
);

TextChunkySvg.displayName = 'TextChunkySvg';
export default TextChunkySvg;
